import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotificationLayout } from '../../../shared/layout/notification-layout/notification-layout';

@Component({
  selector: 'app-internal-error',
  imports: [RouterLink, NotificationLayout],
  templateUrl: './internal-error.html',
  styleUrl: './internal-error.scss',
})
export class InternalError {}
